export const flattenFilterConfigs = (sections = []) => {
  const output = [];

  sections.forEach((section) => {
    if (!section || !Array.isArray(section.configs)) return;

    section.configs.forEach((config) => {
      if (!config) return;
      if (Array.isArray(config.configs)) {
        output.push(...config.configs.filter(Boolean));
      } else {
        output.push(config);
      }
    });
  });

  return output;
};


